// extracted by mini-css-extract-plugin
export default {"posters_container":"Posters_posters_container__Y4KYM"};